import { useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';
import { useNotifier } from '@provider/notifier';
import { useUserIdentityState } from '@provider/user-identity';
import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import { getComponentEntryQueryKey } from '../../../api.component-entry/query.get.js';

const modalConfig = {
  theme: "dialog",
  heading: "Del med lærer",
  body: /*#__PURE__*/jsxs(Fragment, {
    children: ["Del din besvarelse med din l\xE6rer. Hvis du p\xE5 et senere tidspunkt arbejder videre med din besvarelse, vil din l\xE6rer kunne se disse \xE6ndringer.", /*#__PURE__*/jsx("br", {}), "Vi g\xF8r opm\xE6rksom p\xE5, at du ikke kan fortryde en deling med din l\xE6rer."]
  }),
  labels: {
    cancel: "Fortryd",
    ok: "Del med lærer"
  }
};
function useFinishComponentInteraction(args) {
  const queryClient = useQueryClient();
  const user = useUserIdentityState(state => state.user);
  const notifier = useNotifier();
  return useCallback(async () => {
    const entry = queryClient.getQueryData(getComponentEntryQueryKey(args.entryKey));

    // if the component has already been finished and shared beforehand when
    // closing it, then simply do nothing.
    if (entry?.envelope.shared) {
      args.onClose?.();
      return;
    }

    // Teachers cannot share with themselves, and hence we do not bother with
    // the share prompt
    if (user?.role !== "student") {
      args.onClose?.();
      return;
    }
    const res = await notifier.confirm(modalConfig);
    if (res === "ok") {
      args.onShareWithTeacher();
      args.onClose?.();
    }
  }, [args, notifier, queryClient, user?.role]);
}

export { useFinishComponentInteraction };
//# sourceMappingURL=interaction.finish.js.map
